import { useState } from 'react';
import { CaptionButton } from '~/shared/components/ui/Button';
import {
  EstimateBasicInfoRegistrationDialog,
  EstimateBasicInfoRegistrationInfo,
} from '~/shared/components/ui/Dialog/EstimateBasicInfoRegistrationDialog';

export const UISampleEstimateBasicInfoRegistrationDialogs = () => {
  const [result, setResult] = useState<string>('');
  const [isShowDialog, setIsShowDialog] = useState(false);

  return (
    <div className="categories">
      <h3 id="dialog">見積基本情報登録ダイアログ</h3>
      <div className="input-line">
        <div className="item-group-100">
          <div className="w-33">
            <CaptionButton
              buttonType="basic"
              caption="確認する"
              name=""
              onClick={() => {
                setResult('');
                setIsShowDialog(true);
              }}
            />
            <EstimateBasicInfoRegistrationDialog
              isOpen={isShowDialog}
              inputOption={{}}
              onDecision={(v: EstimateBasicInfoRegistrationInfo) => {
                setResult(JSON.stringify(v));
                setIsShowDialog(false);
              }}
              onCancel={() => {
                setResult('');
                setIsShowDialog(false);
              }}
            />
          </div>
          <div className="w-66">
            <pre className="output">
              {result && JSON.stringify(result, null, 2)}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};
